<template>
  <base-dialog :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('clients.api_keys.delete_secret')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="flex flex-col text-center items-center p-4 dark:text-darkblue-200">
        <p class="mb-4">{{messageWarning}}</p>
        <p class="mb-8">{{ $t('clients.api_keys.delete_continue') }}</p>
      </div>
    </template>
    <template slot="footer">
      <div class="flex flex-row gap-2 w-full">
        <base-button-responsive @click="toggleDialog" mode="secondary-phantom-blue" icon="check" class="flex-1 w-full" :text="$t('app.cancel')" :loading="isGeneralLoading"/>
        <base-button-responsive @click="apply" icon="plus" mode="secondary-phantom-blue" class="flex-1 w-full" :text="$t('invoices.invoices_issuing.step0.modal_continue')" :loading="isGeneralLoading"/>
      </div> 
    </template>
  </base-dialog>
</template>

<script>

import { i18n } from '@/i18n'

export default
{
  name: 'user-delete-apikey-dialog',
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      messageWarning: i18n.t('clients.api_keys.delete_secret_message'),
      isOpen: this.dialogOpen,
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
  },
  mounted: async function () {
  },
  methods: {
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    apply: function () {
      this.toggleDialog()
      this.$emit('applyDialog')
    },
  }
}
</script>

<style lang="scss" scoped></style>
